import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import loadable from '@loadable/component';
import {
	ServicesContent,
	TopWrapper,
	TitleWrapper,
	ServicesTitle,
	ServicesItem,
	ServicesWrapper,
	ServicesPrice,
} from './styles';
import { Container } from '../../../components/Layout/styles';
import { Section } from '../styles';
import Button from '../../../components/Button2.0';
import { retailServices } from '../../../components/Icons';
import { formatValuesNumber } from '../../../utils/formatting';
import type { TCity } from '../../../types/city';
import type { TServices, TServicesItem } from '../../../types/services';
import Label from '../../../components/Label';
import { useModal } from '../../../utils/hooks';
import { CLEAR_ACTION_CALLBACK_POPUP } from '../../../constants/popup';
import type { TDispatch } from '../../../types/core';
import { FormWrapper } from '../../../components/ApartPage/styles';

const Modal = loadable(() => import('../../../components/Modal'), { fallback: null, ssr: false });
const CallbackForm = loadable(() => import('../../../components/CallbackModalForm'), { fallback: null, ssr: false });

const RetailServices = () => {
	const dispatch: TDispatch = useDispatch();
	const city: TCity = useSelector((state) => state.city);
	const servicesState: TServices = useSelector((state) => state.services);

	const {
		data: { services },
		isLoaded,
	} = servicesState;

	const currentCity =
		city.link === 'spb' || city.link === 'msk' || city.link === 'nsk' || city.link === 'kzn' ? city.link : 'other';

	const [modalTitle, setModalTitle] = useState('');
	const { isShowing, toggle } = useModal();

	const closeModal = () => {
		toggle();
		dispatch({ type: CLEAR_ACTION_CALLBACK_POPUP });
	};

	const openModal = (item) => {
		setModalTitle(item.title);
		toggle();
	};

	if (isLoaded)
		return (
			<Section id="SectionRetail" type="retail">
				<Container>
					<ServicesContent>
						{services?.map(
							(item: TServicesItem) =>
								!item.package && (
									<ServicesItem key={item.id} id={`services${item.id}`}>
										<ServicesWrapper>
											<TopWrapper>
												<Label icon={retailServices}>Розничные услуги</Label>
											</TopWrapper>
											<TitleWrapper>
												<ServicesTitle>{item.title}</ServicesTitle>
												<ServicesPrice>
													{formatValuesNumber(
														item.prices[currentCity].pricePostpayment ??
															item.prices[currentCity].pricePrepayment,
														'rub',
													)}
												</ServicesPrice>
											</TitleWrapper>
											<Button
												color="secondary"
												size="s"
												style={{ marginTop: 'auto' }}
												/* isLink
												to={`/${city.link}/service/${item.code}/order/`} */
												onClick={() => openModal(item)}
											>
												Заказать
											</Button>
										</ServicesWrapper>
									</ServicesItem>
								),
						)}
					</ServicesContent>
				</Container>
				<Modal isShowing={isShowing} hide={closeModal}>
					<FormWrapper>
						<CallbackForm callbackType="callback" handleTitle={`Заказ услуги «${modalTitle}»`} />
					</FormWrapper>
				</Modal>
			</Section>
		);
	return null;
};
export default RetailServices;
